/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OpportunityTypeResponse } from './';
import {
    OpportunityTypeResponseFromJSON,
    OpportunityTypeResponseFromJSONTyped,
    OpportunityTypeResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateReferralSubmissionOpportunityTypeRequest
 */
export interface UpdateReferralSubmissionOpportunityTypeRequest {
    /**
     * 
     * @type {OpportunityTypeResponse}
     * @memberof UpdateReferralSubmissionOpportunityTypeRequest
     */
    type: OpportunityTypeResponse;
}

/**
 * Check if a given object implements the UpdateReferralSubmissionOpportunityTypeRequest interface.
 */
export function instanceOfUpdateReferralSubmissionOpportunityTypeRequest(value: object): value is UpdateReferralSubmissionOpportunityTypeRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UpdateReferralSubmissionOpportunityTypeRequestFromJSON(json: any): UpdateReferralSubmissionOpportunityTypeRequest {
    return UpdateReferralSubmissionOpportunityTypeRequestFromJSONTyped(json, false);
}

export function UpdateReferralSubmissionOpportunityTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralSubmissionOpportunityTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': OpportunityTypeResponseFromJSON(json['type']),
    };
}

export function UpdateReferralSubmissionOpportunityTypeRequestToJSON(value?: UpdateReferralSubmissionOpportunityTypeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': OpportunityTypeResponseToJSON(value['type']),
    };
}

